import React from 'react'
import { Dialog } from 'primereact/dialog'
import { Divider } from 'primereact/divider'

import { parseDateTime } from '../../../common/date-time'

const ReseStoreInfoDialouge= ({dialougeData, setDialougeData}) => {
    const createdAt = !!dialougeData && parseDateTime(dialougeData.createdTimestamp)
    const modifiedBy = !!dialougeData && dialougeData.modifiedBy ? dialougeData.modifiedBy : "NA"
    const modifiedAt = !!dialougeData && dialougeData.modifiedTimestamp ? parseDateTime(dialougeData.modifiedTimestamp) : "NA"
    return (
        <div>
            <Dialog visible={!!dialougeData} header="Request Info" onHide={() => setDialougeData(null)} style={{width: "40vw"}}>
                <div>
                    <p>
                        <span style={{fontWeight: "700"}}>Created By : </span>
                        {dialougeData?.createdBy}
                    </p>
                    <Divider/>
                    <p>
                        <span style={{fontWeight: "700"}}>Created At : </span>
                        {createdAt}
                    </p>
                    <Divider/>
                    <p>
                        <span style={{fontWeight: "700"}}>Modified By : </span>
                        {modifiedBy}
                    </p>
                    <Divider/>
                    <p>
                        <span style={{fontWeight: "700"}}>Modified At : </span>
                        {modifiedAt}
                    </p>
                    <Divider/>
                </div>
            </Dialog>
        </div>
    )
}

export default ReseStoreInfoDialouge;